The URL of the privacy policy to show to the candidate.
